import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  pt: {
    desativAnim: "Desativar animação",
    inicioNav: `In${"í"}cio`,
    sobreNav: "Sobre",
    palesoNav: "Palestrantes",
    patroNav: "Patrocinadores",
    orgNav: "Organização",
    semanaTec: "VII Semana de Tecnologia da Informação",
    local: "Universidade Federal de Lavras",
    data: "6 a 10 de Novembro de 2023",
    entrarButton: "ENTRAR",
    cadastreButton: "INSCREVA-SE",
    tituloSobre: "COMP",
    textoSobre:
      "Fala, galera! Sejam bem vindos a página de um dos melhores eventos de tecnologia da informação da região <b>100% online e gratuito</b>. Faça já sua inscrição para participar dessa imersão de uma semana às principais tendências da área da tecnologia em um ambiente propício para aproximar empresas e telespectadores da CompWeek!",
    tituloPalestrante: "PALESTRANTES",
    tituloPatrocinadores: "PATROCINADORES",
    cotaDiamante: "DIAMANTE",
    cotaOuro: "OURO",
    cotaPrata: "PRATA",
    tituloOrganizacao: `ORGANIZA${"Ç"}${"Ã"}O`,
    tituloParceiras: "PARCEIRAS",
    tituloApoio: "APOIO",
    tituloLocalizacao: `LOCALIZA${"Ç"}${"Ã"}O`,
    tituloRedesSociais: "REDES SOCIAIS",
    tituloContato: "CONTATO",
    textoLocalizacao: "TOTALMENTE <b>ONLINE</b> E DIRETO DA SUA CASA",
    //textoLocalizacaocasa: "UFLA - Lavras - MG",
    textoContato: "contato@compjunior.com.br",
    queroPalestrar: "QUERO PALESTRAR",
    feedbackButton: "FEEDBACK",
  },
  en: {
    desativAnim: "Disable animation",
    inicioNav: "Home",
    sobreNav: "About",
    palesoNav: "Speakers",
    patroNav: "Sponsors",
    orgNav: "Organization",
    semanaTec: "VII Information Technology Week",
    local: "Federal University of Lavras",
    data: "November 6th to 10th 2023",
    entrarButton: "SIGN IN",
    cadastreButton: "SUBSCRIBE",
    tituloSobre: "THE SETI",
    textoSobre:
      "Hey, folks! Welcome to the page of one of the best <b>100% online and free</b> information technology events in the region. Register now to join this one-week immersion into the latest technology trends in an environment designed to bring companies and viewers closer to CompWeek!",
    tituloPalestrante: "SPEAKERS",
    tituloPatrocinadores: "SPONSORS",
    cotaDiamante: "DIAMOND",
    cotaOuro: "GOLD",
    cotaPrata: "SILVER",
    tituloOrganizacao: "ORGANIZATION",
    tituloParceiras: "PARTNERS",
    tituloApoio: "SUPPORT",
    tituloLocalizacao: "LOCATION",
    tituloRedesSociais: "SOCIAL MEDIA",
    tituloContato: "CONTACT US",
    textoLocalizacao: "COMPLETELY <b>ONLINE</b> AND FROM YOUR HOME",
    //textoLocalizacaocasa: "UFLA - Lavras - MG",
    textoContato: "contato@compjunior.com.br",
    queroPalestrar: "BE A SPEAKER",
    feedbackButton: "FEEDBACK",
  },
};

const i18n = new VueI18n({
  runtimeOnly: false,
  locale: "pt", // set locale
  fallbackLocale: "en", // set fallback locale
  messages, // set locale messages
});

export default i18n;
